import React, { Component } from 'react';
import './textbox.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
//import { layer } from '@fortawesome/fontawesome-svg-core';
import InputMask from 'react-input-mask';



class TextBox extends Component {
    constructor(props) {
      super(props);
      // PROPS
      /*
        --config={color:"#aad",readOnly:false/true, maxLength:0, textAlign:"left/center/right"}
          // color = hexa color for CSS text
          // readOnly = bool remove input to a read only textbox
          // maxlength = char max, if 0 no limit
          // textAlign = how to handle text position
        --updateValue  //callbackMethod
      */
      // State is in reducers
        this.state = {
            value:this.props.value,
            message:"",
        };

  }


  // INNER METHOD
  onFocus = (e)=>{
    e.target.select();
  }
  
  updateValue = (e) =>{
    if(this.props.config.maxLength>0 && e.target.value.length >= this.props.config.maxLength){
      var newValue = e.target.value.substring(0, this.props.config.maxLength);
      this.setState({value:newValue, message:"max length reached ("+this.props.config.maxLength+")"});
      this.props.updateValue(newValue);
    }else{
      this.setState({value:e.target.value, message:""});
      this.props.updateValue(e.target.value);
    }
    
  }

  onRemoveTag = (e) =>{
    console.log("remove",e);
    var tags = null;
    tags = this.props.value.split(",");
    this.props.updateValue(tags.filter(tag => tag !==e).join(","));
  }

  buildTagContent = () =>{
    var content = null;
    var tags = null;
    tags = this.props.value.split(",").map((tag,id)=>{
    return <div key={id} className="tag"><span>{tag}</span><FontAwesomeIcon onClick={this.onRemoveTag.bind(this,tag)} icon="times"/></div>;
    });

    content = <div className="tag-container">{tags}</div>;

    return content;
  }


  componentDidMount = () =>{
    // if(this.props.value !== undefined){
    //   this.setState({value:this.props.value});
    // }
    
  }
  

  // ---------------------RENDER --------------------- 
  render() {
    var labelStyle = {color: this.props.config.color,textAlign:this.props.config.textAlign};
    var message=this.state.message;
    var value =this.props.value;
    var tagContent = null;
    var content=null;

    

    if(this.props.config.readOnly){
      message = "read only";
      content = <div style={labelStyle} className="readOnly">{this.state.value}</div>;
    }else{
      if(this.props.config.tagMode){
        tagContent = this.buildTagContent();
      }
      if(this.props.config.mask !== null && this.props.config.mask !== undefined){
        //message = "expected format: "+this.props.config.mask;
        content = <InputMask alwaysShowMask={true} mask={this.props.config.mask} maskChar=" " value={value} onFocus={this.onFocus.bind(this)} style={labelStyle} onChange={this.updateValue.bind(this)} />;
      }else{
        content = <input onFocus={this.onFocus.bind(this)} style={labelStyle} type="text" value={value} onChange={this.updateValue.bind(this)} />
      }
    }

    return (
          <div className={"textBox "+this.props.config.additionalClass} >
              {tagContent}
              {content}
              <span className="text">{message}</span>
          </div>
    );
  }
}
  
  const mapStateToProps = (state) => {    
    return {  
      
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(TextBox);
  